export function portalTokenFromHash(hash: string): string | null {
  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const token = params.get('portal')?.trim();
  return token || null;
}

export function portalManagePath(token: string): string {
  return `/api/portal/${encodeURIComponent(token)}/manage`;
}
